import { Injectable, inject, DestroyRef } from "@angular/core";
import { I18nService } from "@app/core/services/i18n.service";
import { DecimalPipe } from "@angular/common";
import { MatPaginatorIntl } from "@angular/material/paginator";
import { takeUntilDestroyed } from "@angular/core/rxjs-interop";

@Injectable({
  providedIn: "root"
})
export class I18nPaginatorService extends MatPaginatorIntl {
  private i18nService = inject(I18nService);
  private decimalPipe = inject(DecimalPipe);
  private _destroyRef = inject(DestroyRef);
  public ofLabel = "of";

  constructor() {
    super();
    this._getAndInitTranslations();
  }

  /**
   * @returns A label for the range of items within the current page and the length of the whole list
   */
  override getRangeLabel = (page: number, pageSize: number, length: number): string => {
    if (length === 0 || pageSize === 0) {
      return `0 ${this.ofLabel} ${this.decimalPipe.transform(length)}`;
    }
    length = Math.max(length, 0);
    const startIndex = page * pageSize;
    const endIndex = startIndex < length ? Math.min(startIndex + pageSize, length) : startIndex + pageSize;
    return `${this.decimalPipe.transform(startIndex + 1)} - ${this.decimalPipe.transform(endIndex)} ${
      this.ofLabel
    } ${this.decimalPipe.transform(length)}`;
  };

  /**
   * Initialize pager translations
   */
  private _getAndInitTranslations(): void {
    this.i18nService.translateService
      .selectTranslate([
        "MATERIAL.PAGINATOR.LBL_ITEMS_PER_PAGE",
        "MATERIAL.PAGINATOR.LBL_FIRST_PAGE",
        "MATERIAL.PAGINATOR.LBL_NEXT_PAGE",
        "MATERIAL.PAGINATOR.LBL_PREVIOUS_PAGE",
        "MATERIAL.PAGINATOR.LBL_LAST_PAGE",
        "MATERIAL.PAGINATOR.LBL_OF"
      ])
      .pipe(takeUntilDestroyed(this._destroyRef))
      .subscribe((translation) => {
        this.itemsPerPageLabel = translation[0];
        this.firstPageLabel = translation[1];
        this.nextPageLabel = translation[2];
        this.previousPageLabel = translation[3];
        this.lastPageLabel = translation[4];
        this.ofLabel = translation[5];
        this.changes.next();
      });
  }
}
